<template>
    <div>
        <!-- MENSAJES DE CONFIRMACIÓN -->
        <mensajeSistema></mensajeSistema>

        <!-- CARD IZQUIERDO Y CARD DERECHO  -->
        <v-row>

            <!-- CARD CON RADIO BUTTON DE LOS TIPOS REPORTE -->
            <v-col cols="12" md="4">
                <v-card outlined>
                    <v-card-title>
                        <v-row dense>
                            <v-col cols="12">
                                <v-alert color="primary" class="text-center white--text" dense>
                                    Formato de reportes
                                </v-alert>
                            </v-col>
                        </v-row>

                    </v-card-title>
                    <v-card-text>
                        <v-radio-group v-model="radioGroup">
                            <v-radio v-on:change="showFilters(item.codigo)" v-for="item in listaFormatoReportes"
                                :key="item.codigo" :label="item.descripcion" :value="item.codigo"></v-radio>
                        </v-radio-group>
                    </v-card-text>
                </v-card>
            </v-col>

            <!-- CARD CON LOS BOTONES EXCEL, PDF Y LOS FILTROS -->
            <v-col cols="12" md="8">
                <v-card outlined>
                    <v-card-title>
                        <v-row dense>
                            <v-col cols="12">
                                <v-alert color="primary" class="text-center white--text" dense>
                                    Parámetros del reporte
                                </v-alert>
                            </v-col>
                        </v-row>
                    </v-card-title>
                    <v-card-text>

                        <!-- BOTÓN EXCEL Y PDF -->
                        <template v-if="codigoReporte != '' || codigoReportePdf != ''">
                            <v-row>
                                <v-col cols="12" id="btn_generar_excel" class="d-flex justify-end">
                                    <v-btn :loading="loading" style="width: 180px;" color="success"
                                        v-on:click="generarExcel" class="mx-2">
                                        'Generar Excel'
                                        <v-icon right small>fa-file-excel</v-icon>
                                    </v-btn>
                                    <v-btn :loading="loadingPdf" color="red" style="width: 168px;" v-on:click="generarPdf"
                                        class="white--text mx-2">
                                        'Generar PDF'
                                        <v-icon right small>fa-file-pdf</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </template>

                        <!-- USUARIOS DEL SISTEMA -->
                        <template v-if="codigoReporte == 'usuarios_sistemas' || codigoReportePdf == 'usuarios_sistemas'">
                            <div class="legend">
                                <h4 class="legend-title">
                                    Este informe muestra los datos de todos los usuarios registrados en el sistema,
                                    incluyendo detalles como el tipo y número de documento, el nombre de usuario, el correo
                                    electrónico, el número de teléfono, el perfil y el estado.
                                </h4>
                            </div>
                            <v-row>
                                <v-col cols="12" sm="4">
                                    <v-select @change="seleccionarPerfil(perfilSelected)" :items="perfiles"
                                        v-model="perfilSelected" item-text="descripcion_perfil" item-value="id"
                                        label="Perfil"></v-select>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-select @change="seleccionarEstado(estadoSelected)" :items="estados"
                                        v-model="estadoSelected" item-text="descripcion" item-value="id"
                                        label="Estado del usuario"></v-select>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-select @change="seleccionarRango(rangoSelected)" :items="cantidadResultados"
                                        v-model="rangoSelected" item-text="descripcion" item-value="id"
                                        label="Resultados por página"></v-select>
                                </v-col>
                            </v-row>
                        </template>

                        <!-- ACADÉMICOS - ESTUDIANTE -->
                        <template v-if="codigoReporte == 'academicos_alumnos' || codigoReportePdf == 'academicos_alumnos'">
                            <div class="legend">
                                <h4 class="legend-title">
                                    Este informe detalla el registro de todos los estudiantes del colegio; aquí se puede
                                    encontrar el tipo y número de documento, los nombres y apellidos, el correo, el
                                    teléfono, el nivel, el grado, la sección y el sexo.
                                </h4>
                            </div>
                            <v-row>
                                <v-col cols="12" sm="4">
                                    <v-select @change="seleccionarAnioLectivo(anioLectivoSelected)" :items="aniosLectivos"
                                        v-model="anioLectivoSelected" :item-text="anoLectivoCompuesto"
                                        item-value="idAnioLectivo" label="Año lectivo"></v-select>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-select @change="seleccionarNivel(nivelSelected)" :items="niveles"
                                        v-model="nivelSelected" item-text="desc_nivel" item-value="id_nivel"
                                        label="Nivel"></v-select>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-select @change="seleccionarGrado(gradoSelected)" :items="grados"
                                        v-model="gradoSelected" item-text="desc_grado" item-value="id"
                                        label="Grado"></v-select>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-select @change="seleccionarSeccion(seccionSelected)" :items="secciones"
                                        v-model="seccionSelected" item-text="nombre_seccion" item-value="id"
                                        label="Sección"></v-select>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-select @change="seleccionarSexo(sexoSelected)" :items="sexos" v-model="sexoSelected"
                                        item-text="descripcion" item-value="id" label="Sexo"></v-select>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-select @change="seleccionarRango(rangoSelected)" :items="cantidadResultados"
                                        v-model="rangoSelected" item-text="descripcion" item-value="id"
                                        label="Resultados por página"></v-select>

                                </v-col>
                            </v-row>
                        </template>

                        <!-- ACADÉMICOS - DOCENTE -->
                        <template
                            v-if="codigoReporte == 'academicos_docentes' || codigoReportePdf == 'academicos_docentes'">
                            <div class="legend">
                                <h4 class="legend-title">
                                    Este reporte muestra datos del docente tales como el tipo y número de documento, los
                                    apellidos y nombres, el correo y el teléfono. Así mismo, se indica el nivel, el grado,
                                    el nombre de la sección, el área y los cursos que el profesor enseña.
                                </h4>
                            </div>
                            <v-row>
                                <v-col cols="12" sm="4">
                                    <v-select @change="seleccionarAnioLectivo(anioLectivoSelected)" :items="aniosLectivos"
                                        v-model="anioLectivoSelected" :item-text="anoLectivoCompuesto"
                                        item-value="idAnioLectivo" label="Año lectivo"></v-select>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-select @change="seleccionarNivel(nivelSelected)" :items="niveles"
                                        v-model="nivelSelected" item-text="desc_nivel" item-value="id_nivel"
                                        label="Nivel"></v-select>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-select @change="seleccionarGrado(gradoSelected)" :items="grados"
                                        v-model="gradoSelected" item-text="desc_grado" item-value="id"
                                        label="Grado"></v-select>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-select @change="seleccionarSeccion(seccionSelected)" :items="secciones"
                                        v-model="seccionSelected" item-text="nombre_seccion" item-value="id"
                                        label="Sección"></v-select>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-select @change="seleccionarArea(areaSelected)" :items="areas" v-model="areaSelected"
                                        item-text="desc_area" item-value="id_area" label="Área"></v-select>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-select @change="seleccionarRango(rangoSelected)" :items="cantidadResultados"
                                        v-model="rangoSelected" item-text="descripcion" item-value="id"
                                        label="Resultados por página"></v-select>
                                </v-col>
                            </v-row>
                        </template>

                        <!-- CLASES DEL DOCENTE -->
                        <template v-if="codigoReporte == 'clases_docente' || codigoReportePdf == 'clases_docente'">
                            <div class="legend">
                                <h4 class="legend-title">
                                    Este reporte lleva un control de los registros de las clases del docente; incluye la
                                    unidad, el tema, la fecha, la hora de inicio, la hora de finalización y, además, muestra
                                    si la clase ya ha sido programada o ejecutada.
                                </h4>
                            </div>
                            <v-row>
                                <v-col cols="12" sm="4">
                                    <v-select @change="seleccionarAnioLectivoClasesDocente(anioLectivoSelected)"
                                        :items="aniosLectivos" v-model="anioLectivoSelected"
                                        :item-text="anoLectivoCompuesto" item-value="idAnioLectivo"
                                        label="Año lectivo"></v-select>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-select @change="seleccionarDocente(docenteSelected)" :items="docentes"
                                        v-model="docenteSelected" item-text="nombre_pers" item-value="id_personal"
                                        label="Docente"></v-select>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-select @change="seleccionarNivelProfesor(nivelSelected)" :items="nivelesDocente"
                                        v-model="nivelSelected" item-text="desc_nivel" item-value="id_nivel"
                                        label="Nivel"></v-select>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-select @change="seleccionarGradoProfesor(gradoSelected)" :items="gradosDocente"
                                        v-model="gradoSelected" item-text="desc_grado" item-value="id_grado"
                                        label="Grado"></v-select>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-select @change="seleccionarSeccionProfesor(seccionSelected)"
                                        :items="seccionesDocente" v-model="seccionSelected" item-text="nombre_seccion"
                                        item-value="id_seccion" label="Sección"></v-select>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-select @change="seleccionarAreaProfesor(areaSelected)" :items="areasDocente"
                                        v-model="areaSelected" item-text="desc_area" item-value="id_area"
                                        label="Área"></v-select>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-select @change="seleccionarCursoProfesor(cursoSelected)" :items="cursosDocente"
                                        v-model="cursoSelected" item-text="desc_curso" item-value="id_curso"
                                        label="Curso"></v-select>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-select @change="seleccionarEstadoClase(estadoClaseSelected)" :items="estadosClases"
                                        v-model="estadoClaseSelected" item-text="desc_estado_clase"
                                        item-value="id_estado_clase" label="Estado de la clase"></v-select>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-select @change="seleccionarRango(rangoSelected)" :items="cantidadResultados"
                                        v-model="rangoSelected" item-text="descripcion" item-value="id"
                                        label="Resultados por página"></v-select>

                                </v-col>
                            </v-row>
                        </template>

                        <!-- CONTROL DE ACCESOS -->
                        <template v-if="codigoReporte == 'control_de_accesos' || codigoReportePdf == 'control_de_accesos'">
                            <div class="legend">
                                <h4 class="legend-title">
                                    Este reporte lleva un control de las fechas de acceso y salida de la plataforma para
                                    todos los perfiles o el perfil seleccionado a través del filtro.
                                </h4>
                            </div>
                            <v-row>
                                <v-col cols="12" sm="4">
                                    <v-select @change="seleccionarPerfil(perfilSelected)" :items="perfiles"
                                        v-model="perfilSelected" item-text="descripcion_perfil" item-value="id"
                                        label="Perfil"></v-select>
                                </v-col>

                                <v-col cols="12" sm="4">
                                    <v-menu v-model="menu1" :close-on-content-click="false" transition="scale-transition"
                                        offset-y max-width="290px" min-width="auto">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field v-model="computedDateFormatted" label="Fecha de inicio"
                                                persistent-hint prepend-icon="mdi-calendar" readonly v-bind="attrs"
                                                v-on="on"></v-text-field>
                                        </template>
                                        <v-date-picker v-model="date" no-title @input="menu1 = false"></v-date-picker>
                                    </v-menu>
                                </v-col>

                                <v-col cols="12" sm="4">
                                    <v-menu v-model="menu2" :close-on-content-click="false" transition="scale-transition"
                                        offset-y max-width="290px" min-width="auto">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field v-model="computedDateFormatted2" label="Fecha de finalización"
                                                persistent-hint prepend-icon="mdi-calendar" readonly v-bind="attrs"
                                                v-on="on"></v-text-field>
                                        </template>
                                        <v-date-picker v-model="date2" no-title @input="menu2 = false"></v-date-picker>
                                    </v-menu>
                                </v-col>


                                <v-col cols="12" sm="4">
                                    <v-select @change="seleccionarRango(rangoSelected)" :items="cantidadResultados"
                                        v-model="rangoSelected" item-text="descripcion" item-value="id"
                                        label="Resultados por página"></v-select>

                                </v-col>
                            </v-row>
                        </template>

                        <!-- HORARIO DE LA SECCIÓN -->
                        <template v-if="codigoReporte == 'horario_clase' || codigoReportePdf == 'horario_clase'">
                            <div class="legend">
                                <h4 class="legend-title">
                                    Este reporte muestra el horario de una sección en específico.
                                </h4>
                            </div>
                            <v-row>
                                <v-col cols="12" sm="4">
                                    <v-select @change="seleccionarAnioLectivo(anioLectivoSelected)" :items="aniosLectivos"
                                        v-model="anioLectivoSelected" :item-text="anoLectivoCompuesto"
                                        item-value="idAnioLectivo" label="Año lectivo"></v-select>
                                </v-col>

                                <v-col cols="12" sm="4">
                                    <v-select @change="seleccionarNivelAdm(nivelSelected)" :items="niveles"
                                        v-model="nivelSelected" item-text="desc_nivel" item-value="id"
                                        label="Nivel"></v-select>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-select @change="seleccionarGradoAdm(gradoSelected)" :items="grados"
                                        v-model="gradoSelected" item-text="desc_grado" item-value="id"
                                        label="Grado"></v-select>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-select @change="seleccionarSeccion(seccionSelected)" :items="seccionesHorario"
                                        v-model="seccionSelected" item-text="nombre_seccion" item-value="id"
                                        label="Sección"></v-select>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-select @change="seleccionarAreaAdm(areaSelected)" :items="areasAdm"
                                        v-model="areaSelected" item-text="desc_area" item-value="id"
                                        label="Área"></v-select>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-select @change="seleccionarCurso(cursoSelected)" :items="cursos"
                                        v-model="cursoSelected" item-text="desc_curso" item-value="id"
                                        label="Curso"></v-select>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-select @change="seleccionarRango(rangoSelected)" :items="cantidadResultados"
                                        v-model="rangoSelected" item-text="descripcion" item-value="id"
                                        label="Resultados por página"></v-select>

                                </v-col>
                            </v-row>
                        </template>

                        <!-- CONSOLIDADO DE NOTAS -->
                        <template v-if="codigoReporte == 'consolidado_notas' || codigoReportePdf == 'consolidado_notas'">
                            <div class="legend">
                                <h4 class="legend-title">
                                    Este reporte presenta un informe detallado del rendimiento académico de los estudiantes,
                                    destacando sus promedios en las áreas y cursos, así como las competencias, capacidades y
                                    desempeños dentro de cada área. Existen dos tipos de formato para este reporte: el
                                    formato ‘Minedu’ y el formato ‘Global’. El primero genera un informe únicamente de las
                                    áreas, mientras que el segundo proporciona detalles sobre los cursos dentro de cada
                                    área.
                                </h4>
                            </div>
                            <v-row>
                                <v-col cols="12" sm="4" class="d-flex justify-center">
                                    <v-switch v-model="switchValue" :label="switchValue ? 'Global' : 'Minedu'"></v-switch>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-select @change="seleccionarAnioLectivo(anioLectivoSelected)" :items="aniosLectivos"
                                        v-model="anioLectivoSelected" :item-text="anoLectivoCompuesto"
                                        item-value="idAnioLectivo" label="Año lectivo"></v-select>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-select @change="seleccionarNivel(nivelSelected)" :items="niveles"
                                        v-model="nivelSelected" item-text="desc_nivel" item-value="id_nivel"
                                        label="Nivel"></v-select>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-select @change="seleccionarPeriodo(periodoSelected)" :items="periodos"
                                        v-model="periodoSelected" item-text="nombre_periodo" item-value="id"
                                        label="Periodo"></v-select>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-select @change="seleccionarGrado(gradoSelected)" :items="grados"
                                        v-model="gradoSelected" item-text="desc_grado" item-value="id"
                                        label="Grado"></v-select>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-select @change="seleccionarSeccion(seccionSelected)" :items="secciones"
                                        v-model="seccionSelected" item-text="nombre_seccion" item-value="id"
                                        label="Sección"></v-select>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-select @change="seleccionarArea(areaSelected)" :items="areasAdm"
                                        v-model="areaSelected" item-text="desc_area" item-value="id"
                                        label="Área"></v-select>
                                </v-col>
                                <v-col v-if="switchValue" cols="12" sm="4">
                                    <v-select @change="seleccionarCurso(cursoSelected)" :items="cursos"
                                        v-model="cursoSelected" item-text="desc_curso" item-value="id"
                                        label="Curso"></v-select>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-select @change="seleccionarRango(rangoSelected)" :items="cantidadResultados"
                                        v-model="rangoSelected" item-text="descripcion" item-value="id"
                                        label="Resultados por página"></v-select>

                                </v-col>
                            </v-row>
                        </template>

                        <!-- ASISTENCIA POR SECCIÓN -->
                        <template v-if="codigoReporte == 'asistencia_seccion' || codigoReportePdf == 'asistencia_seccion'">
                            <div class="legend">
                                <h4 class="legend-title">
                                    Reporte donde se refleja el registro de asistencias a clase de los estudiantes,
                                    organizado por sección.
                                </h4>
                            </div>
                            <v-row>
                                <v-col cols="12" sm="4">
                                    <v-select @change="seleccionarAnioLectivo(anioLectivoSelected)" :items="aniosLectivos"
                                        v-model="anioLectivoSelected" :item-text="anoLectivoCompuesto"
                                        item-value="idAnioLectivo" label="Año lectivo"></v-select>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-select @change="seleccionarNivel(nivelSelected)" :items="niveles"
                                        v-model="nivelSelected" item-text="desc_nivel" item-value="id_nivel"
                                        label="Nivel"></v-select>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-select @change="seleccionarGrado(gradoSelected)" :items="grados"
                                        v-model="gradoSelected" item-text="desc_grado" item-value="id"
                                        label="Grado"></v-select>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-select @change="seleccionarSeccion(seccionSelected)" :items="secciones"
                                        v-model="seccionSelected" item-text="nombre_seccion" item-value="id"
                                        label="Sección"></v-select>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-menu v-model="menu3" :close-on-content-click="false" transition="scale-transition"
                                        offset-y max-width="290px" min-width="auto">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field v-model="computedDateFormatted3" label="Fecha" persistent-hint
                                                prepend-icon="mdi-calendar" readonly v-bind="attrs"
                                                v-on="on"></v-text-field>
                                        </template>
                                        <v-date-picker v-model="date3" no-title @input="menu3 = false"></v-date-picker>
                                    </v-menu>
                                </v-col>



                            </v-row>
                        </template>

                        <!-- PRIMEROS PUESTOS -->
                        <template v-if="codigoReporte == 'primeros_puestos' || codigoReportePdf == 'primeros_puestos'">
                            <div class="legend">
                                <h4 class="legend-title">
                                    Reporte donde se refleja los primeros puestos por Grado y sección.
                                </h4>
                            </div>
                            <v-row>
                                <v-col cols="12" sm="4">
                                    <v-select @change="seleccionarAnioLectivo(anioLectivoSelected)" :items="aniosLectivos"
                                        v-model="anioLectivoSelected" :item-text="anoLectivoCompuesto"
                                        item-value="idAnioLectivo" label="Año lectivo"></v-select>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-select @change="seleccionarNivel(nivelSelected)" :items="niveles"
                                        v-model="nivelSelected" item-text="desc_nivel" item-value="id_nivel"
                                        label="Nivel"></v-select>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-select @change="seleccionarGrado(gradoSelected)" :items="grados"
                                        v-model="gradoSelected" item-text="desc_grado" item-value="id"
                                        label="Grado"></v-select>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-select @change="seleccionarSeccion(seccionSelected)" :items="secciones"
                                        v-model="seccionSelected" item-text="nombre_seccion" item-value="id"
                                        label="Sección" :clearable="seccionSelected ? seccionSelected : seccionSelected = -1"></v-select>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-select v-model="tercioSelected" :items="terciosPuestos"
                                         item-text="name" item-value="value"
                                        label="Puestos" :clearable="tercioSelected ? tercioSelected : tercioSelected = -1"></v-select>
                                </v-col>
                                <!-- <v-col cols="12" sm="4">
                                    <v-menu v-model="menu3" :close-on-content-click="false" transition="scale-transition"
                                        offset-y max-width="290px" min-width="auto">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field v-model="computedDateFormatted3" label="Fecha" persistent-hint
                                                prepend-icon="mdi-calendar" readonly v-bind="attrs"
                                                v-on="on"></v-text-field>
                                        </template>
                                        <v-date-picker v-model="date3" no-title @input="menu3 = false"></v-date-picker>
                                    </v-menu>
                                </v-col> -->



                            </v-row>
                        </template>

                    </v-card-text>
                </v-card>
            </v-col>

        </v-row>

    </div>
</template>
<script>
import { mapMutations, mapGetters } from 'vuex';
import axios, { BUCKET_ORIGIN_SPACE } from '@/helpers/axios';

export default {
    data: () => ({
        idColegio: parseInt(sessionStorage.getItem('id_colegio')),
        anioSelected: (new Date()).getFullYear().toString(),
        clear:-1,

        //-- Date pickers - Format
        menu1: false,
        menu2: false,
        menu3: false,
        date: '',
        date2: '',
        date3: '',
        dateFormatted: '',
        dateFormatted2: '',
        dataFormatted3: '',

        //-- Generando reportes (loadings and state)
        loading: false,
        loadingPdf: false,
        generandoReporte: 0,
        generandoReportePdf: 0,

        //-- Mostrar los filtros and codigo reporte
        showFilter: 0,
        radioGroup: "",
        codigoReporte: "",
        codigoReportePdf: "",
        switchValue: false,

        //--Filtros Seleccionados
        perfilSelected: "-1",
        estadoSelected: '-1',
        rangoSelected: '50',
        anioLectivoSelected: '',
        nivelSelected: '-1',
        gradoSelected: '-1',
        seccionSelected: '-1',
        areaSelected: '-1',
        sexoSelected: 'T',
        periodoSelected: '-1',
        docenteSelected: '-1',
        cursoSelected: '-1',
        estadoClaseSelected: '-1',
        fecha_inicio: "",
        fecha_fin: "",
        nivelEvalSelected: "-1",
        cursoAlumnoSelected: "-1",

        //Variables para el tercio Superior
        tercioSelected: null,
        terciosPuestos:[
            {
                name: "Tercio superior",
                value:3
            },
            {
                name: "Cuarto superior",
                value:4
            },
            {
                name: "Quinto superior",
                value:5
            },
            {
                name: "Sexto superior",
                value:6
            },
        ],

        //-- Radio buttons
        listaFormatoReportes: [
            {
                codigo: "usuarios_sistemas",
                descripcion: 'Usuarios del sistema'
            },
            {
                codigo: "academicos_alumnos",
                descripcion: 'Académico - Estudiante'
            },
            {
                codigo: "academicos_docentes",
                descripcion: 'Académico - Docente'
            },
            {
                codigo: "clases_docente",
                descripcion: "Clases del docente",
            },
            {
                codigo: "control_de_accesos",
                descripcion: "Control de accesos"
            },
            {
                codigo: "horario_clase",
                descripcion: "Horario de clase"
            },
            {
                codigo: "consolidado_notas",
                descripcion: "Consolidado de notas"
            },
            {
                codigo: "asistencia_seccion",
                descripcion: "Asistencia por sección"
            },
            {
                codigo: "primeros_puestos",
                descripcion: "Primeros puestos"
            },
            
        ],

        //--Arrays
        perfiles: [],
        aniosLectivos: [],
        niveles: [],
        nivelesDocente: [{ id_nivel: '-1', desc_nivel: 'Todos' }],

        grados: [{ id: '-1', desc_grado: 'Todos' }],
        gradosDocente: [{ id_grado: '-1', desc_grado: 'Todos' }],

        secciones: [{ id: '-1', nombre_seccion: 'Todos' }],
        seccionesHorario: [],
        seccionesDocente: [{ id_seccion: '-1', nombre_seccion: 'Todos' }],

        areas: [{ id_area: '-1', desc_area: 'Todos' }],
        areasAdm: [{ id: '-1', desc_area: 'Todos' }],
        areasDocente: [{ id_area: '-1', desc_area: 'Todos' }],

        cursos: [{ id_curso: '-1', desc_curso: 'Todos' }],
        cursosDocente: [{ id_curso: '-1', desc_curso: 'Todos' }],

        periodos: [{ id: '-1', nombre_periodo: 'Todos' }], //Ojo aca

        docentes: [],

        estadosClases: [
            { id_estado_clase: '-1', desc_estado_clase: 'Todos' },
            { id_estado_clase: '1', desc_estado_clase: 'Programada' },
            { id_estado_clase: '2', desc_estado_clase: 'Reprogramada' },
            { id_estado_clase: '3', desc_estado_clase: 'Sin ejecutar' },
            { id_estado_clase: '4', desc_estado_clase: 'Ejecutada' },
            { id_estado_clase: '5', desc_estado_clase: 'Actualizada' },
        ],

        estados: [
            { id: '-1', descripcion: 'Todos' },

            { id: '1', descripcion: 'Activos' },
            { id: '2', descripcion: 'Inactivos' },
        ],
        sexos: [
            { id: 'T', descripcion: 'Todos' },
            { id: 'M', descripcion: 'Masculino' },
            { id: 'F', descripcion: 'Femenino' },
        ],
        cantidadResultados: [
            { codigo: '1', descripcion: '1' },
            { codigo: '50', descripcion: '50' },
            { codigo: '50', descripcion: '100' },
            { codigo: '50', descripcion: '200' },
        ],

        consolidadoResultados: [
            { id: "todas", descripcion: "Todas" },
            { id: "competencia", descripcion: "Competencia" },
            { id: "capacidades", descripcion: "Capacidades" },
            { id: "desempeños", descripcion: "Desempeños" }
        ]
    }),

    mounted() {
        let idColegio = sessionStorage.getItem('id_colegio');
        this.getPerfiles(idColegio);
        this.getNiveles(null, null);
        this.getAnioLectivos(idColegio);
    },

    computed: {
        ...mapGetters('login', ['componenteEvento']),
        computedDateFormatted() {
            return this.formatDate(this.date)
        },
        computedDateFormatted2() {
            return this.formatDate(this.date2)
        },
        computedDateFormatted3() {
            return this.formatDate(this.date3)
        }
    },

    watch: {
        date() {
            this.dateFormatted = this.formatDate(this.date)
        },
        date2() {
            this.dateFormatted2 = this.formatDate(this.date2)
        },
        date3() {
            this.dataFormatted3 = this.formatDate(this.date3)
        },
        switchValue(newValue) {
            if (!newValue) {
                this.cursoSelected = -1;
            }
        }
    },

    methods: {
        formatDate(date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
        parseDate(date) {
            if (!date) return null

            const [month, day, year] = date.split('/')
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        },
        hide: async function () {
            this.anioLectivoSelected.destroy()
            this.aniosLectivos.destroy()
        },

        ...mapMutations('mensajeSis', ['setEnviarMens']),

        showFilters: function (_codigoReporte) {
            this.radioGroup = _codigoReporte;
            this.codigoReporte = _codigoReporte;
            this.codigoReportePdf = _codigoReporte;
            if (this.showFilter != 0) {
                this.limpiarFiltros();
            }
            this.showFilter += 1;
        },

        //Peticiones al back
        async getPerfiles(idColegio) {
            let response = await axios.get('/reporte/formatoReporte/perfiles/' + idColegio)
            let perfilesList = response.data
            perfilesList.unshift({ id: '-1', descripcion_perfil: 'Todos' })
            this.perfiles = perfilesList
        },

        async getAnioLectivos(idColegio) {
            let response = await axios.get('/reporte/formatoReporte/aniosElectivos/' + idColegio)
            let anioLectivosList = response.data
            this.aniosLectivos = anioLectivosList
        },

        async getNiveles(idColegio, idAnioLectivo) {
            let response = await axios.post('/reporte/formatoReporte/getNiveles', {
                idAnioLectivo: idAnioLectivo,
                idColegio: idColegio
            })
            let nivelesist = (response.data.legth == 0) ? new Array() : response.data
            this.niveles = nivelesist
        },

        async getGrados(idColegio, idAnioLectivo, idNivel) {
            let response = await axios.post('/reporte/formatoReporte/getGrados', {
                idAnioLectivo: idAnioLectivo,
                idColegio: idColegio,
                idNivel: idNivel
            })
            let gradosList = response.data
            this.grados = gradosList
        },

        async getGradosAdm(idColegio, idAnioLectivo, idNivel) {
            let response = await axios.post('/reporte/formatoReporte/getGradosAdm', {
                idAnioLectivo: idAnioLectivo,
                idColegio: idColegio,
                idNivel: idNivel
            })
            let gradosList = response.data
            gradosList.unshift({ id: '-1', desc_grado: 'Todos' })
            this.grados = gradosList

        },

        async getSeccion(idColegio, idAnioLectivo, idGrado) {
            let response = await axios.post('/reporte/formatoReporte/getSecciones', {
                idAnioLectivo: idAnioLectivo,
                idColegio: idColegio,
                idGrado: idGrado
            })
            let seccionesList = response.data
            //seccionesList.unshift({ id: '-1', nombre_seccion: 'Todos' })
            this.secciones = seccionesList
        },

        async getSeccionAdm(idColegio, idAnioLectivo, idGrado) {
            let response = await axios.post('/reporte/formatoReporte/getSecciones', {
                idAnioLectivo: idAnioLectivo,
                idColegio: idColegio,
                idGrado: idGrado
            })

            this.seccionesHorario = response.data
            let seccionesList = [...response.data]
            seccionesList.unshift({ id: '-1', nombre_seccion: 'Todos' })
            this.secciones = seccionesList

        },


        async getAreas(idColegio, idAnioLectivo, idNivel) {
            let response = await axios.post('/administrativo/area/areasNivelAdmin', {
                idAnioLectivo: idAnioLectivo,
                idColegio: idColegio,
                idNivel: idNivel
            })
            let areasList = response.data[0].json
            areasList.unshift({ id_area: '-1', desc_area: 'Todos' })
            this.areas = areasList

        },

        async getAreasAdm(idColegio, idAnioLectivo, idGrado) {
            let response = await axios.post('/reporte/formatoReporte/getAreasAdm', {
                idAnioLectivo: idAnioLectivo,
                idColegio: idColegio,
                idGrado: idGrado
            })

            let areasList = response.data
            this.areasAdm = [{ id: '-1', desc_area: 'Todos' }, ...areasList]

        },

        async getPeriodos(idColegio, idAnioLectivo, idNivel) {
            let response = await axios.post('/reporte/formatoReporte/getPeriodos', {
                idColegio,
                idAnioLectivo,
                idNivel,
            })
            let periodosList = response.data
            periodosList.unshift({ id: '-1', nombre_periodo: 'Todos' })
            this.periodos = periodosList
        },

        async getPeriodosDocente(idColegio, idAnioLectivo, idNivel) {
            let response = await axios.post('/reporte/formatoReporte/getPeriodoDocente', {
                idColegio: idColegio,
                idAnioLectivo: idAnioLectivo,
                idNivel: idNivel
            })
            let periodosList = response.data
            periodosList.unshift({ id: '-1', nombre_periodo: 'Todos' })
            this.periodos = periodosList
        },

        async getDocentes(idColegio, idAnioLectivo) {
            let response = await axios.post('/reporte/formatoReporte/getDocentes', {
                idColegio,
                idAnioLectivo
            })
            let docentesList = response.data
            this.docentes = docentesList
        },

        async getNivelesProfesor(idColegio, idAnioLectivo, idProfesor) {
            let response = await axios.post('/reporte/formatoReporte/getNivelesDocente', {
                idColegio,
                idAnioLectivo,
                idProfesor
            })
            let listNivelesDocente = response.data
            listNivelesDocente.unshift({ id_nivel: '-1', desc_nivel: 'Todos' })
            this.nivelesDocente = listNivelesDocente
        },

        async getGradosProfesor(idColegio, idAnioLectivo, idProfesor, idNivel) {
            let response = await axios.post('/reporte/formatoReporte/getGradosDocente', {
                idColegio,
                idAnioLectivo,
                idProfesor,
                idNivel
            })
            let listGradosDocente = response.data
            listGradosDocente.unshift({ id_grado: '-1', desc_grado: 'Todos' })
            this.gradosDocente = listGradosDocente
        },

        async getAreasProfesor(idColegio, idAnioLectivo, idProfesor, idNivel) {
            let response = await axios.post('/reporte/formatoReporte/getAreasDocente', {
                idColegio,
                idAnioLectivo,
                idProfesor,
                idNivel
            })
            let listAreasDocente = response.data
            listAreasDocente.unshift({ id_area: '-1', desc_area: 'Todos' })
            this.areasDocente = listAreasDocente
        },

        async getSeccionesProfesor(idColegio, idAnioLectivo, idNivel, idGrado, idDocente) {
            let response = await axios.post('/reporte/formatoReporte/getSeccionesDocente', {
                idColegio,
                idAnioLectivo,
                idNivel,
                idGrado,
                idDocente,
            })
            let listSeccionesDocente = response.data
            listSeccionesDocente.unshift({ id_seccion: '-1', nombre_seccion: 'Todos' })
            this.seccionesDocente = listSeccionesDocente
        },

        async getCursos(idColegio, idAnioLectivo, idNivel, idGrado, idArea) {
            let response = await axios.post('/reporte/formatoReporte/getCursos', {
                idColegio,
                idAnioLectivo,
                idNivel,
                idGrado,
                idArea,
            })
            let listCursos = response.data
            this.cursos = listCursos
        },

        async getCursosAdm(idColegio, idAnioLectivo, idNivel, idGrado, idArea) {
            let response = await axios.post('/reporte/formatoReporte/getCursosAdm', {
                idColegio,
                idAnioLectivo,
                idNivel,
                idGrado,
                idArea,
            })
            let listCursos = response.data
            listCursos.unshift({ id_curso: '-1', desc_curso: 'Todos' })
            this.cursos = listCursos
        },

        async getCursosProfesor(idColegio, idAnioLectivo, idArea, idGrado, idDocente) {
            let response = await axios.post('/reporte/formatoReporte/getCursosDocente', {
                idColegio,
                idAnioLectivo,
                idArea,
                idGrado,
                idDocente,
            })
            let listCursosDocente = response.data
            listCursosDocente.unshift({ id_curso: '-1', desc_curso: 'Todos' })
            this.cursosDocente = listCursosDocente
        },

        async generarExcel() {
            this.loading = true;

            try {
                this.generandoReporte = 1
                this.setEnviarMens({ tipo: 'S', mensaje: 'Generando reporte…', tiempo: 3000 })
                let codigoReporte = this.codigoReporte;

                let data = {};
                let archivoADescargar = '';
                if (codigoReporte == 'usuarios_sistemas') {
                    data = {
                        perfil: parseInt(this.perfilSelected),
                        estado: parseInt(this.estadoSelected)
                    }
                }
                if (codigoReporte == 'academicos_alumnos') {
                    data = {
                        anioLectivo: parseInt(this.anioLectivoSelected),
                        nivel: parseInt(this.nivelSelected),
                        grado: parseInt(this.gradoSelected),
                        seccion: parseInt(this.seccionSelected),
                        sexo: this.sexoSelected,
                    }
                }
                if (codigoReporte == 'academicos_docentes') {
                    data = {
                        anioLectivo: parseInt(this.anioLectivoSelected),
                        nivel: parseInt(this.nivelSelected),
                        grado: parseInt(this.gradoSelected),
                        seccion: parseInt(this.seccionSelected),
                        area: parseInt(this.areaSelected)
                    }
                }
                if (codigoReporte == 'clases_docente') {
                    if (parseInt(this.docenteSelected) == -1) {
                        this.setEnviarMens({ tipo: 'W', mensaje: 'Debe seleccionar al profesor.', tiempo: 3000 })
                        this.generandoReporte = 0
                        return false
                    }
                    data = {
                        anioLectivo: parseInt(this.anioLectivoSelected),
                        nivel: parseInt(this.nivelSelected),
                        docente: parseInt(this.docenteSelected),
                        grado: parseInt(this.gradoSelected),
                        seccion: parseInt(this.seccionSelected),
                        area: parseInt(this.areaSelected),
                        curso: parseInt(this.cursoSelected),
                        estado: parseInt(this.estadoClaseSelected),
                    }
                }
                if (codigoReporte == 'control_de_accesos') {
                    data = {
                        perfil: parseInt(this.perfilSelected),
                        fecha_inicio: this.date,
                        fecha_fin: this.date2,
                    }
                }
                if (codigoReporte == 'horario_clase') {

                    if (parseInt(this.seccionSelected) == -1) {
                        this.setEnviarMens({ tipo: 'W', mensaje: 'Debe seleccionar una Sección', tiempo: 3000 })
                        this.generandoReporte = 0
                        return false
                    }
                    data = {
                        anioLectivo: parseInt(this.anioLectivoSelected),
                        nivel: parseInt(this.nivelSelected),
                        grado: parseInt(this.gradoSelected),
                        seccion: parseInt(this.seccionSelected),
                        area: parseInt(this.areaSelected),
                        curso: typeof this.cursoSelected === 'number' ? parseInt(this.cursoSelected) : this.cursoSelected,

                    }
                }
                if (codigoReporte == 'consolidado_notas') {
                    data = {
                        anioLectivo: parseInt(this.anioLectivoSelected),
                        periodo: parseInt(this.periodoSelected),
                        nivel: parseInt(this.nivelSelected),
                        grado: parseInt(this.gradoSelected),
                        seccion: parseInt(this.seccionSelected),
                        area: parseInt(this.areaSelected),
                        curso: parseInt(this.cursoSelected),
                        minedu: this.switchValue,
                    }
                }
                if (codigoReporte == 'asistencia_seccion') {
                    data = {
                        anioLectivos: parseInt(this.anioLectivoSelected),
                        nivel: parseInt(this.nivelSelected),
                        grado: parseInt(this.gradoSelected),
                        seccion: parseInt(this.seccionSelected),
                        fecha: this.date3,
                    }
                }
                if (codigoReporte == 'primeros_puestos') {
                    data = {
                        anioLectivos: parseInt(this.anioLectivoSelected),
                        nivel: parseInt(this.nivelSelected),
                        grado: parseInt(this.gradoSelected),
                        seccion: parseInt(this.seccionSelected),
                        puesto: this.tercioSelected,
                        // fecha: this.date3,
                    }
                    
                }

                //Seleccionar todos los campos
                let todosLosCamposValidos = true;
        
                for (let campo in data) {
                    if (campo != 'minedu') {
                        if (!data[campo] && data[campo] !== 0) {
                            todosLosCamposValidos = false;
                            break;
                        }
                    }
                }

                if (codigoReporte == 'academicos_alumnos' && (data.anioLectivo == null || data.anioLectivo === '' || Number.isNaN(data.anioLectivo))) {
                    this.setEnviarMens({ tipo: 'W', mensaje: 'Debes seleccionar un año lectivo!', tiempo: 3000 })
                    return
                }

                if (codigoReporte == 'academicos_docentes' && (data.anioLectivo == null || data.anioLectivo === '' || Number.isNaN(data.anioLectivo))) {
                    this.setEnviarMens({ tipo: 'W', mensaje: 'Debes seleccionar un año lectivo!', tiempo: 3000 })
                    return
                }

                if (codigoReporte == 'consolidado_notas' && (data.seccion == -1)) {
                    this.setEnviarMens({ tipo: 'W', mensaje: 'Debes seleccionar una sección y un área!', tiempo: 3000 })
                    return
                }

                if (!todosLosCamposValidos && codigoReporte == 'consolidado_notas') {
                    this.setEnviarMens({ tipo: 'W', mensaje: 'Debe terminar de seleccionar todos los filtros.', tiempo: 3000 })
                    return
                }

                if (codigoReporte == 'asistencia_seccion' && (data.fecha == '' || data.seccion == -1)) {
                    this.setEnviarMens({ tipo: 'W', mensaje: 'Debes seleccionar una sección y una fecha.', tiempo: 3000 })
                    return
                }
                if (codigoReporte == 'primeros_puestos' && (data.anioLectivos == null || data.anioLectivos === '' || Number.isNaN(data.anioLectivos))) {
                    this.setEnviarMens({ tipo: 'W', mensaje: 'Debes seleccionar un año lectivo!', tiempo: 3000 })
                    return
                }

                data.colegio = parseInt(sessionStorage.getItem('id_colegio'))
                data.tamanioPorHoja = parseInt(this.rangoSelected)
                data.codigoReporte = codigoReporte

                //generamos el reporte
                data.BUCKET_ORIGIN_SPACE = BUCKET_ORIGIN_SPACE
       
                let response = await axios.post("/reporte/formatoReporte/generarReporte", data);
                let dataResponse = response.data
    
                this.setEnviarMens({ tipo: dataResponse.messageT, mensaje: dataResponse.message, tiempo: 3000 })
                this.generandoReporte = 0
                if (dataResponse.messageT == 'S') {
               
                    archivoADescargar = dataResponse.fileToDownload;
                    axios({
                        url: '/reporte/formatoReporte/bajarReporte/' + dataResponse.nameReport,
                        method: 'GET',
                        responseType: 'blob', // important
                    }).then((response) => {
                        this.setEnviarMens({ tipo: 'S', mensaje: '¡Descargando reporte.!', tiempo: 3000 })

                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', archivoADescargar);
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                        window.URL.revokeObjectURL(url);
                    });
                }


            } catch (error) {
                this.generandoReporte = 0
                this.setEnviarMens({ tipo: 'E', mensaje: 'No se pudo generar el reporte. Por favor, vuelva a intentarlo.', tiempo: 3000 })
            } finally {
                this.loading = false;

            }

        },

        async generarPdf() {
            this.loadingPdf = true;
            try {
                this.generandoReportePdf = 1
                this.setEnviarMens({ tipo: 'S', mensaje: 'Generando reporte…', tiempo: 3000 })

                let codigoReportePdf = this.codigoReportePdf;
                let data = {};
                let archivoADescargar = '';

                if (codigoReportePdf == 'usuarios_sistemas') {
                    data = {
                        perfil: parseInt(this.perfilSelected),
                        estado: parseInt(this.estadoSelected)
                    }
                }
                if (codigoReportePdf == 'academicos_alumnos') {
                    data = {
                        anioLectivo: parseInt(this.anioLectivoSelected),
                        nivel: parseInt(this.nivelSelected),
                        grado: parseInt(this.gradoSelected),
                        seccion: parseInt(this.seccionSelected),
                        sexo: this.sexoSelected,
                    }
                }
                if (codigoReportePdf == 'academicos_docentes') {
                    data = {
                        anioLectivo: parseInt(this.anioLectivoSelected),
                        nivel: parseInt(this.nivelSelected),
                        grado: parseInt(this.gradoSelected),
                        seccion: parseInt(this.seccionSelected),
                        area: parseInt(this.areaSelected)
                    }
                }
                if (codigoReportePdf == 'clases_docente') {
                    if (parseInt(this.docenteSelected) == -1) {
                        this.setEnviarMens({ tipo: 'W', mensaje: 'Debe seleccionar al profesor.', tiempo: 3000 })
                        this.generandoReporte = 0
                        return false
                    }
                    data = {
                        anioLectivo: parseInt(this.anioLectivoSelected),
                        nivel: parseInt(this.nivelSelected),
                        docente: parseInt(this.docenteSelected),
                        grado: parseInt(this.gradoSelected),
                        seccion: parseInt(this.seccionSelected),
                        area: parseInt(this.areaSelected),
                        curso: parseInt(this.cursoSelected),
                        estado: parseInt(this.estadoClaseSelected),
                    }
                }
                if (codigoReportePdf == 'control_de_accesos') {
                    data = {
                        perfil: parseInt(this.perfilSelected),
                        fecha_inicio: this.date,
                        fecha_fin: this.date2,
                    }
                }
                if (codigoReportePdf == 'horario_clase') {

                    if (parseInt(this.seccionSelected) == -1) {
                        this.setEnviarMens({ tipo: 'W', mensaje: 'Debe seleccionar una Sección', tiempo: 3000 })
                        this.generandoReporte = 0
                        return false
                    }
                    data = {
                        anioLectivo: parseInt(this.anioLectivoSelected),
                        nivel: parseInt(this.nivelSelected),
                        grado: parseInt(this.gradoSelected),
                        seccion: parseInt(this.seccionSelected),
                        area: parseInt(this.areaSelected),
                        curso: parseInt(this.cursoSelected),

                    }
                }
                if (codigoReportePdf == 'consolidado_notas') {
                    data = {
                        anioLectivo: parseInt(this.anioLectivoSelected),
                        periodo: parseInt(this.periodoSelected),
                        nivel: parseInt(this.nivelSelected),
                        grado: parseInt(this.gradoSelected),
                        seccion: parseInt(this.seccionSelected),
                        area: parseInt(this.areaSelected),
                        curso: parseInt(this.cursoSelected),
                        minedu: this.switchValue,
                    }
                }
                if (codigoReportePdf == 'asistencia_seccion') {
                    data = {
                        anioLectivos: parseInt(this.anioLectivoSelected),
                        nivel: parseInt(this.nivelSelected),
                        grado: parseInt(this.gradoSelected),
                        seccion: parseInt(this.seccionSelected),
                        fecha: this.date3,
                    }
                }
                if (codigoReportePdf == 'primeros_puestos') {
                    data = {
                        anioLectivos: parseInt(this.anioLectivoSelected),
                        nivel: parseInt(this.nivelSelected),
                        grado: parseInt(this.gradoSelected),
                        seccion: parseInt(this.seccionSelected),
                        puesto: this.tercioSelected,
                        // fecha: this.date3,
                    }
                    
                }
                

                //Seleccionar todos los campos
                let todosLosCamposValidos = true;
                for (let campo in data) {
                    if (campo != 'minedu') {
                        if (!data[campo] && data[campo] !== 0) {
                            todosLosCamposValidos = false;
                            break;
                        }
                    }
                }

                if (codigoReportePdf == 'academicos_alumnos' && (data.anioLectivo == null || data.anioLectivo === '' || Number.isNaN(data.anioLectivo))) {
                    this.setEnviarMens({ tipo: 'W', mensaje: 'Debes seleccionar un año lectivo!', tiempo: 3000 })
                    return
                }
                if (codigoReportePdf == 'academicos_docentes' && (data.anioLectivo == null || data.anioLectivo === '' || Number.isNaN(data.anioLectivo))) {
                    this.setEnviarMens({ tipo: 'W', mensaje: 'Debes seleccionar un año lectivo!', tiempo: 3000 })
                    return
                }
                if (codigoReportePdf == 'consolidado_notas' && (data.area == -1 || data.seccion == -1)) {
                    this.setEnviarMens({ tipo: 'W', mensaje: 'Debes seleccionar una sección y un área!', tiempo: 3000 })
                    return
                }
                if (!todosLosCamposValidos && codigoReportePdf == 'consolidado_notas') {
                    this.setEnviarMens({ tipo: 'W', mensaje: 'Debes terminar de seleccionar todos los filtros!', tiempo: 3000 })
                    return
                }
                if (codigoReportePdf == 'primeros_puestos' && (data.anioLectivos == null || data.anioLectivos === '' || Number.isNaN(data.anioLectivos))) {
                    this.setEnviarMens({ tipo: 'W', mensaje: 'Debes seleccionar un año lectivo!', tiempo: 3000 })
                    return
                }


                data.colegio = parseInt(sessionStorage.getItem('id_colegio'))
                data.tamanioPorHoja = parseInt(this.rangoSelected)
                data.codigoReporte = codigoReportePdf
                data.BUCKET_ORIGIN_SPACE = BUCKET_ORIGIN_SPACE

                //generamos el reporte
                let response = await axios.post("/reporte/formatoReporte/generarReportePdf", data);
                let dataResponse = response.data
                this.setEnviarMens({ tipo: dataResponse.messageT, mensaje: dataResponse.message, tiempo: 3000 })
                this.generandoReportePdf = 0
                if (dataResponse.messageT == 'S') {
                    archivoADescargar = dataResponse.fileToDownload;
                    axios({
                        url: '/reporte/formatoReporte/bajarReporte/' + dataResponse.nameReport,
                        method: 'GET',
                        responseType: 'blob', // important
                    }).then((response) => {
                        this.setEnviarMens({ tipo: 'S', mensaje: 'Descargando reporte', tiempo: 3000 })

                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', archivoADescargar);
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                        window.URL.revokeObjectURL(url);
                    });

                }

            } catch (error) {
                this.generandoReportePdf = 0
            } finally {
                this.loadingPdf = false;
            }

        },

        async descargarBlob() {
            axios({
                url: '/reporte/formatoReporte/descargarBlob',
                method: 'GET',
                responseType: 'blob',
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'colegioasd.png');
                document.body.appendChild(link);
                link.click();
            });
        },

        //Disparadores
        seleccionarPerfil(id) {
            this.perfilSelected = id
        },

        seleccionarEstado(id) {
            this.estadoSelected = id
        },

        seleccionarAnio(idAnio) {
            this.anioSelected = idAnio
        },

        seleccionarRango(id) {
            this.rangoSelected = id
        },

        seleccionarAnioLectivo(idAnioLectivo) {
            this.periodos = []
            this.docentes = []
            this.nivelesDocente = []
            this.gradosDocente = []
            this.seccionesDocente = []
            this.areasDocente = []
            this.cursosDocente = []
            this.anioLectivoSelected = idAnioLectivo
            console.log("SeleccionanioLectivo", this.anioLectivoSelected, idAnioLectivo)
            this.getNiveles(this.idColegio, idAnioLectivo)
        },

        seleccionarAnioLectivoClasesDocente(idAnioLectivo) {
            this.getDocentes(this.idColegio, idAnioLectivo)
            this.getNiveles(this.idColegio, idAnioLectivo)
        },

        seleccionarNivel(idNivel) {
            this.areasAdm.splice(0)
            this.secciones.splice(0)
            if (this.anioLectivoSelected != '-1') {
                this.nivelSelected = idNivel
                this.getPeriodos(this.idColegio, this.anioLectivoSelected, idNivel)
                this.getGrados(this.idColegio, this.anioLectivoSelected, idNivel)
                this.getAreas(this.idColegio, this.anioLectivoSelected, idNivel)

            }
        },

        seleccionarNivelAdm(idNivel) {
            if (this.anioLectivoSelected != '-1') {
                this.nivelSelected = idNivel
                this.getGradosAdm(this.idColegio, this.anioLectivoSelected, idNivel)
            }
        },

        seleccionarNivelProfesor(idNivel) {
            this.gradosDocente = []
            this.seccionesDocente = []
            this.areasDocente = []
            this.cursosDocente = []
            if (this.anioLectivoSelected != '-1') {
                this.nivelSelected = idNivel
                this.getGradosProfesor(this.idColegio, this.anioLectivoSelected, this.docenteSelected, idNivel)
                this.getAreasProfesor(this.idColegio, this.anioLectivoSelected, this.docenteSelected, idNivel)
            }

            this.getPeriodosDocente(this.idColegio, this.anioLectivoSelected, idNivel)
        },

        seleccionarGrado(idGrado) {
            this.gradoSelected = idGrado
            this.getSeccion(this.idColegio, this.anioLectivoSelected, idGrado)
            this.getAreasAdm(this.idColegio, this.anioLectivoSelected, idGrado)
        },

        seleccionarGradoAdm(idGrado) {
            this.gradoSelected = idGrado
            this.getSeccionAdm(this.idColegio, this.anioLectivoSelected, idGrado)
            this.getAreasAdm(this.idColegio, this.anioLectivoSelected, idGrado)
        },

        seleccionarGradoProfesor(idGrado) {
            this.seccionesDocente = []
            this.cursosDocente = []
            this.gradoSelected = idGrado
            this.getSeccionesProfesor(this.idColegio, this.anioLectivoSelected, this.nivelSelected, idGrado, this.docenteSelected)
        },

        seleccionarSeccion(idSeccion) {
            this.seccionSelected = idSeccion
            this.getAreas(this.idColegio, this.anioLectivoSelected, this.nivelSelected)
        },

        seleccionarSeccionProfesor(idSeccion) {
            this.cursosDocente = []
            this.seccionSelected = idSeccion
        },

        seleccionarArea(idArea) {
            this.areaSelected = idArea
            //Aca debo modificar la query
            
            if(this.switchValue == true) {
                this.getCursos(this.idColegio, this.anioLectivoSelected, this.nivelSelected, this.gradoSelected, idArea);
            }
        },

        seleccionarAreaAdm(idArea) {
            this.areaSelected = idArea
            this.getCursosAdm(this.idColegio, this.anioLectivoSelected, this.nivelSelected, this.gradoSelected, idArea)
        },

        seleccionarNivEvaluacion(idEval) {
            this.nivelEvalSelected = idEval
        },

        seleccionarAreaProfesor(idArea) {
            this.cursosDocente = []
            this.areaSelected = idArea
            this.getCursosProfesor(this.idColegio, this.anioLectivoSelected, idArea, this.gradoSelected, this.docenteSelected)
        },
        seleccionarCursoProfesor(idCurso) {
            this.cursoSelected = idCurso
        },

        seleccionarCurso(idCurso) {
            this.cursoSelected = idCurso
        },

        seleccionarSexo(idSexo) {
            this.sexoSelected = idSexo
        },

        seleccionarPeriodo(idPeriodo) {
            this.docentes = []
            this.nivelesDocente = []
            this.gradosDocente = []
            this.seccionesDocente = []
            this.areasDocente = []
            this.cursosDocente = []
            this.areasDocente = []
            this.periodoSelected = idPeriodo
            this.getDocentes(this.idColegio, this.anioLectivoSelected)
        },
        seleccionarPeriodoDocente(idPeriodo) {
            this.periodoSelected = idPeriodo
            this.getDocentes(this.idColegio, this.anioLectivoSelected)
        },
        seleccionarDocente(idDocente) {
            this.nivelesDocente = []
            this.gradosDocente = []
            this.seccionesDocente = []
            this.areasDocente = []
            this.cursosDocente = []
            this.areasDocente = []
            this.docenteSelected = idDocente
            this.getNivelesProfesor(this.idColegio, this.anioLectivoSelected, idDocente)
        },

        anoLectivoCompuesto(item) {
            if (item.fecha_inicio != 'Todos') {
                return item.fecha_inicio + '-' + item.nom_anolectivo;
            }
            return 'Todos';
        },
        limpiarFiltros() {
            this.periodos = [{ id: '-1', nombre_periodo: 'Todos' }]
            this.niveles = [{ id_nivel: '-1', desc_nivel: 'Todos' }];
            this.nivelesDocente = [{ id_nivel: '-1', desc_nivel: 'Todos' }];
            this.grados = [{ id: '-1', desc_grado: 'Todos' }];
            this.gradosDocente = [{ id_grado: '-1', desc_grado: 'Todos' }];
            this.secciones = [{ id: '-1', nombre_seccion: 'Todos' }];
            this.seccionesDocente = [{ id_seccion: '-1', nombre_seccion: 'Todos' }];
            this.areas = [{ id_area: '-1', desc_area: 'Todos' }];
            this.areasAdm = [{ id: '-1', desc_area: 'Todos' }];
            this.areasDocente = [{ id_area: '-1', desc_area: 'Todos' }];
            this.cursos = [{ id_curso: '-1', desc_curso: 'Todos' }];
            this.cursosDocente = [{ id_curso: '-1', desc_curso: 'Todos' }];
            this.docentes = [];

            this.perfilSelected = '-1';
            this.estadoSelected = '-1';
            this.rangoSelected = '50';
            this.anioSelected = '2022';

            this.anioLectivoSelected = '';
            this.nivelSelected = '-1';
            this.gradoSelected = '-1';
            this.cursoSelected = '-1';
            this.seccionSelected = '-1';
            this.periodoSelected = '-1';

            this.seccionSelected = '-1';
            this.areaSelected = '-1';
            this.sexoSelected = 'T';
            this.estadoClaseSelected = '-1';

            this.docenteSelected = '-1';
            this.fecha_inicio = '';
            this.fecha_fin = '';

            this.date = '';
            this.date2 = '';
        },

    },

}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@1,400&display=swap');

.legend {
    margin-top: 12px;
    border: 1px solid #ccc;
    padding: 10px;
    margin-bottom: 20px;
    border-radius: 5px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    font-family: Arial, sans-serif;
}

.legend-title {
    color: #333;
    font-size: 14px;
    font-family: 'Montserrat', sans-serif;
    font-style: italic;
    text-align: justify;
    margin: 0;
    padding: 10px 0;
}
</style>